import { getCampaignBoxes } from "./campaigns";

export const getResultTags = (campaigns, productTags, config, price, max = 2, omnibusPriceTag) => {
  // Dalle campagne recupero i singoli box validi, con aggiunti gli eventuali tag sconto (doppi)

  const campaignBoxes = getCampaignBoxes(campaigns, price).filter(
    (item) => item.tag || item.liferayFields.taxonomyCategoryBriefs.length > 0
  );

  const isDiscount =
    price?.sellingPrice?.value &&
    ((omnibusPriceTag && price.sellingPrice.value < omnibusPriceTag) ||
      (!omnibusPriceTag &&
        price?.msrpPrice?.value &&
        price.sellingPrice.value < price.msrpPrice.value));
  // Se c'è lo sconto sul prodotto e sui tag transformo i tag in sconto
  const tags = [...campaignBoxes].concat(
    productTags.map((tag) =>
      isDiscount && tag.tagActive?.value === "yes" ? { ...tag, price: price } : tag
    )
  );

  // Se c'è lo sconto da configurazioni generali (e sul prodotto) lo aggiungo davanti
  if (isDiscount && config.tagActive === "yes") {
    tags.unshift({
      id: "general_discount",
      colorCategory: {
        value: config.tagColor || ["red"],
      },
      price,
    });
  }
  const resultTags = tags.reduce((res, tag) => {
    // Rimuovo i doppioni
    if (res.every((item) => item.id !== tag.id)) {
      const hasDiscountTag = res.some((item) => item.price);
      // Posso avere solo un tag di sconto
      if (hasDiscountTag && tag.price) {
        // Se è un doppio generato dalle campagne lo devo saltare, altrimenti lo devo ripulire
        if (!tag.id.endsWith("_price")) {
          const { price, ...cleandTag } = tag;
          res.push(cleandTag);
        }
      } else {
        res.push(tag);
      }
    }
    return res;
  }, []);
  return resultTags.slice(0, max);
};
